export default __webpack_public_path__ + "035d55373ad80775ce2f9f132bbdcd49.svg";